// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customizer {
    width: 50%;
    right: -50%;
}
.customizer.open {
    right: 0 !important;
}
.images-preview-main {
    display: grid;
    grid-template-columns: auto auto auto auto;}
.image-preivew {
    padding-right: 1rem;

    .extra-details {
        .dimension {
            display: grid;

            span {
                font-size: 13px;
                font-weight: 500;

            }
        }
        .cancel-img {
            .close-btn {
                border-radius: 50%;
                background-color: red;
                color: white;
                border: 2px solid #fff;
            }
        }

    }
    .err-img {
        border: 2px solid red;
    padding: 5px;
    }
    img {
        height: 150px;
        width: 200px;
        border: 2px solid green;
        padding: 5px;
    }
}
.upload-progress {
    width: 100%;
    text-align: center;
    .bar {
        background-color: green;
    }
}
.img-url-copy  {
    .copy {
        width: 60px;
        font-weight: 500;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/resuable/upload/image-upload/image-upload.component.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,0CAA0C,CAAC;AAC/C;IACI,mBAAmB;;IAEnB;QACI;YACI,aAAa;;YAEb;gBACI,eAAe;gBACf,gBAAgB;;YAEpB;QACJ;QACA;YACI;gBACI,kBAAkB;gBAClB,qBAAqB;gBACrB,YAAY;gBACZ,sBAAsB;YAC1B;QACJ;;IAEJ;IACA;QACI,qBAAqB;IACzB,YAAY;IACZ;IACA;QACI,aAAa;QACb,YAAY;QACZ,uBAAuB;QACvB,YAAY;IAChB;AACJ;AACA;IACI,WAAW;IACX,kBAAkB;IAClB;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":[".customizer {\n    width: 50%;\n    right: -50%;\n}\n.customizer.open {\n    right: 0 !important;\n}\n.images-preview-main {\n    display: grid;\n    grid-template-columns: auto auto auto auto;}\n.image-preivew {\n    padding-right: 1rem;\n\n    .extra-details {\n        .dimension {\n            display: grid;\n\n            span {\n                font-size: 13px;\n                font-weight: 500;\n\n            }\n        }\n        .cancel-img {\n            .close-btn {\n                border-radius: 50%;\n                background-color: red;\n                color: white;\n                border: 2px solid #fff;\n            }\n        }\n\n    }\n    .err-img {\n        border: 2px solid red;\n    padding: 5px;\n    }\n    img {\n        height: 150px;\n        width: 200px;\n        border: 2px solid green;\n        padding: 5px;\n    }\n}\n.upload-progress {\n    width: 100%;\n    text-align: center;\n    .bar {\n        background-color: green;\n    }\n}\n.img-url-copy  {\n    .copy {\n        width: 60px;\n        font-weight: 500;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
